/* Humbler video reels: muted previews play only while visible; tap opens the full player with sound.
   Loading: posters fade in over the tile (assets/humbler-skeleton.js); the player shows a ring while the
   video buffers, and the shop card never shows the previous piece while the next one loads. */
(() => {
  if (window.HumblerReels) return;
  window.HumblerReels = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection && navigator.connection.saveData;

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const video = entry.target;
      if (entry.isIntersecting && !reduceMotion.matches && !saveData) {
        if (!video.src) video.src = video.dataset.src;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }
  }, { threshold: 0.6 }) : null;

  const init = root => root.querySelectorAll('.hb-reels__video[data-src]').forEach(video => observer?.observe(video));
  document.querySelectorAll('[data-hb-reels]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target));

  // Buffering ring: after a beat (fast starts never show it); hidden once frames play.
  const buffering = (player, on) => {
    const ring = player.querySelector('[data-hb-reel-buffering]');
    if (!ring) return;
    clearTimeout(ring.hbTimer);
    if (on) ring.hbTimer = setTimeout(() => { ring.hidden = false; }, 250);
    else ring.hidden = true;
  };
  const bindPlayer = (player, video) => {
    if (player.hbBound) return;
    player.hbBound = true;
    ['loadstart', 'waiting', 'stalled'].forEach(type => video.addEventListener(type, () => { if (player.open && !video.paused) buffering(player, true); }));
    ['playing', 'canplay', 'pause', 'error', 'emptied'].forEach(type => video.addEventListener(type, () => buffering(player, false)));
  };

  document.addEventListener('click', event => {
    const tile = event.target.closest('[data-hb-reel]');
    if (!tile || !tile.dataset.src) return;
    const section = tile.closest('[data-hb-reels]');
    const player = section.querySelector('[data-hb-reel-player]');
    const video = player.querySelector('[data-hb-reel-video]');
    const shop = player.querySelector('[data-hb-reel-shop]');
    bindPlayer(player, video);
    video.src = tile.dataset.src;
    if (tile.dataset.poster) video.poster = tile.dataset.poster;
    shop.hidden = !tile.dataset.productUrl;
    if (tile.dataset.productUrl) {
      shop.href = tile.dataset.productUrl;
      shop.querySelector('[data-hb-reel-shop-title]').textContent = tile.dataset.productTitle;
      shop.querySelector('[data-hb-reel-shop-price]').textContent = tile.dataset.productPrice;
      const image = shop.querySelector('[data-hb-reel-shop-image]');
      if (window.HumblerSkeleton) window.HumblerSkeleton.swapSrc(image, tile.dataset.productImage);
      else image.src = tile.dataset.productImage;
    }
    window.HumblerUI ? window.HumblerUI.openDialog(player, tile) : player.showModal();
    buffering(player, true);
    video.play().then(() => { if (video.readyState >= 3) buffering(player, false); }).catch(() => buffering(player, false));
  });
  document.addEventListener('hb:close', event => {
    const video = event.target.querySelector?.('[data-hb-reel-video]');
    if (video) { video.pause(); video.removeAttribute('src'); video.load(); buffering(event.target, false); }
  }, true);
})();
